/** Read-only star rating with an accessible text alternative. */
export function Rating({ value, count }: { value: number; count?: number }) {
  if (!count) return <span className="text-xs text-slate-500">New</span>;
  return (
    <span className="inline-flex items-center gap-1 text-sm text-slate-700" aria-label={`Rated ${value.toFixed(1)} out of 5 from ${count} reviews`}>
      <svg viewBox="0 0 20 20" className="size-4 fill-amber-400" aria-hidden="true"><path d="M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 14.9 4.8 17.6l1-5.8L1.5 7.7l5.9-.9L10 1.5z" /></svg>
      <span aria-hidden="true">{value.toFixed(1)}</span>
      <span aria-hidden="true" className="text-slate-400">({count})</span>
    </span>
  );
}
